import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'

import Landing from '@/pages/Landing'
import About from '@/pages/About'
import Contact from '@/pages/Contact'
import Showcase from '@/pages/Showcase'
import NotFound from '@/pages/NotFound'

import Home from '@/pages/Home'
import Register from '@/pages_auth/Register'
import Login from '@/pages_auth/Login'
import Verify from '@/pages_auth/Verify'

import Users from '@/pages_auth/Users'
import Projects from '@/pages_auth/Projects'

import LayoutGallery from '@/pages_showcase/LayoutGallery'
import LayoutMasonry from '@/pages_showcase/LayoutMasonry'
import LayoutMasonryInstagram from '@/pages_showcase/LayoutMasonryInstagram'
import ApiPlaces from '@/pages_showcase/ApiPlaces'
import ApiYoutube from '@/pages_showcase/ApiYoutube'

import PrivacyPolicy from '@/pages_misc/PrivacyPolicy'
import TermsOfService from '@/pages_misc/TermsOfService'
import TermsAndPrivacy from '@/pages_misc/TermsAndPrivacy'

import Blogs from '@/pages_test/Blogs'
import Components from '@/pages_test/Components'

Vue.use(VueRouter)
Vue.use(VueMeta)

var vueRouter = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'landing',
      id: 0,
      title: 'Landing',
      component: Landing
    },
    {
      path: '/about',
      name: 'about',
      id: 1,
      title: 'About',
      component: About
    },
    {
      path: '/contact',
      name: 'contact',
      id: 2,
      title: 'Contact',
      component: Contact
    },
    {
      path: '/showcase/:type',
      name: 'showcase',
      id: 3,
      title: 'Showcase',
      component: Showcase
    },
    {
      path: '*',
      name: 'notfound',
      id: -1,
      title: 'Not Found',
      component: NotFound
    },
    // showcase
    {
      path: '/layout-gallery',
      name: 'layout-gallery',
      id: 11,
      title: 'Dynamic Gallery',
      component: LayoutGallery
    },
    {
      path: '/layout-masonry',
      name: 'layout-masonry',
      id: 12,
      title: 'Masonry Layout',
      component: LayoutMasonry
    },
    {
      path: '/layout-masonry-instagram',
      name: 'layout-masonry-instagram',
      id: 13,
      title: 'Masonry Instagram Layout',
      component: LayoutMasonryInstagram
    },
    {
      path: '/api-places',
      name: 'api-places',
      id: 14,
      title: 'Places API',
      component: ApiPlaces
    },
    {
      path: '/api-youtube',
      name: 'api-youtube',
      id: 15,
      title: 'Youtube API',
      component: ApiYoutube
    },
    // auth
    {
      path: '/home',
      name: 'home',
      id: 101,
      title: 'Home',
      component: Home
    },
    {
      path: '/register',
      name: 'register',
      id: 101,
      title: 'Register',
      component: Register
    },
    {
      path: '/login',
      name: 'login',
      id: 102,
      title: 'Login',
      component: Login
    },
    {
      path: '/verify',
      name: 'verify',
      id: 103,
      title: 'Verify',
      component: Verify
    },
    {
      path: '/users',
      name: 'users',
      id: 202,
      title: 'Users',
      component: Users
    },
    {
      path: '/projects',
      name: 'projects',
      id: 203,
      title: 'Projects',
      component: Projects
    },
    // misc
    {
      path: '/privacy',
      name: 'privacy',
      id: 901,
      title: 'Privacy',
      component: PrivacyPolicy
    },
    {
      path: '/terms',
      name: 'terms',
      id: 902,
      title: 'Terms of Service',
      component: TermsOfService
    },
    {
      path: '/privacypolicy',
      name: 'privacypolicy',
      id: 903,
      title: 'Terms of Service &amp; Privacy Policy',
      component: TermsAndPrivacy
    },
    // testing only
    {
      path: '/blogs',
      name: 'blogs',
      id: 911,
      title: 'Blogs',
      component: Blogs
    },
    {
      path: '/components',
      name: 'components',
      id: 912,
      title: 'Components',
      component: Components
    }
  ]
})

export default vueRouter



// WEBPACK FOOTER //
// ./src/router/index.js